import { STATUSES, makeDataState, makePaginationState } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  authorInfo: makeDataState(),
  ranks: makePaginationState(),
  voteEventStories: makeDataState(),
  event: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // author info
    case `${t.FETCH_AUTHOR_INFO}_PENDING`:
      return {
        ...state,
        authorInfo: {
          ...state.authorInfo,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_AUTHOR_INFO}_SUCCESS`:
      return {
        ...state,
        authorInfo: {
          ...state.authorInfo,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_AUTHOR_INFO}_ERROR`:
      return {
        ...state,
        authorInfo: {
          ...state.authorInfo,
          status: STATUSES.ERROR,
        },
      };

    // ranks
    case `${t.FETCH_AUTHOR_RANKS}_PENDING`:
      return {
        ...state,
        ranks: {
          ...state.ranks,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_AUTHOR_RANKS}_SUCCESS`:
      return {
        ...state,
        ranks: {
          ...state.ranks,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          pagination: {
            ...action.payload.result,
            items: state.ranks.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_AUTHOR_RANKS}_ERROR`:
      return {
        ...state,
        ranks: {
          ...state.ranks,
          status: STATUSES.ERROR,
        },
      };

    // vote event
    case `${t.FETCH_VOTE_EVENT_STORIES}_PENDING`:
      return {
        ...state,
        voteEventStories: {
          ...state.voteEventStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_VOTE_EVENT_STORIES}_SUCCESS`:
      return {
        ...state,
        voteEventStories: {
          ...state.voteEventStories,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_VOTE_EVENT_STORIES}_ERROR`:
      return {
        ...state,
        voteEventStories: {
          ...state.voteEventStories,
          status: STATUSES.ERROR,
        },
      };

    // vote event
    case `${t.FETCH_MISSION_EVENTS}_PENDING`:
      return {
        ...state,
        event: {
          ...state.event,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MISSION_EVENTS}_SUCCESS`:
      return {
        ...state,
        event: {
          ...state.event,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };
    case `${t.FETCH_MISSION_EVENTS}_ERROR`:
      return {
        ...state,
        event: {
          ...state.event,
          status: STATUSES.ERROR,
        },
      };

    case `${t.POST_MISSION}_SUCCESS`:
      return {
        ...state,
        event: {
          ...state.event,
          data: {
            ...state.event.data,
            missions: state.event.data.missions.map((mission) => {
              if (mission.type === action.meta.type) {
                return {
                  ...mission,
                  status: 'complete',
                };
              }
              return mission;
            }),
            eventMoney:
              state.event.data.eventMoney +
              (action.meta.type === 'episode_published' ||
              action.meta.type === 'story_donation'
                ? 2
                : 1),
          },
        },
      };

    case `${t.POST_MISSION_RESULT}_SUCCESS`:
      return {
        ...state,
        event: {
          ...state.event,
          data: {
            ...state.event.data,
            eventMoney: state.event.data.eventMoney - 2,
          },
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/events/reducer.js